// src/layouts/AdminLayout.js
import React from 'react'
import {Navigate, Outlet} from 'react-router-dom'
import Navbar from '../components/Navbar' // ajusta ruta si está en otro lado

export default function AdminLayout() {
  const isAuthenticated = localStorage.getItem('usuario') === 'Admin'
  if (!isAuthenticated) return <Navigate to="/" replace />

  return (
    <>
      <Navbar />
      <Outlet />
    </>
  )
}
